module.exports = __webpack_public_path__ + "static/media/comefunziona1.553f81ca.png";